import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { maxLengthText, getMarkdownExcerpt } from "../../../utils/format";
import CustomButton from "../../../components/CustomButton";
import { setSelectedTypeOfTalent } from "../../../reducers/companyContent";

const RankingItem = ({ item }: any) => {
  const navigate = useNavigate();

  return (
    <div className="flex gap-4 group">
      <span className="min-w-2 self-center font-bold leading-[1.3125rem] alu-text-base-2 text-sm">
        {item?.ranking}
      </span>
      <img onClick={() => navigate("/company/news/detail/" + item.id)} src={item.img} alt="ranking" className="shrink-0 w-16 h-16 object-cover group-hover:opacity-80 group-hover:cursor-pointer" />
      <div className="w-[13.75rem] shrink-0">
        <h5
          onClick={() => navigate("/company/news/detail/" + item.id)}
          className="group-hover:underline cursor-pointer underline-offset-1 mb-1 text-sm leading-[1.3125rem] font-bold whitespace-pre-wrap alu-text-base-2 text-link-with-hover"
        >
          {maxLengthText(item.title, 40)}
        </h5>
        <p className="text-sm leading-[1.3125rem] alu-text-base-1">
          {item.views}
        </p>
      </div>
      <div className="flex-1 text-sm leading-[1.3125rem] font-normal alu-text-base-1 ">
        <p className="whitespace-pre-wrap line-clamp-2">
          {getMarkdownExcerpt(item.description)}
        </p>
      </div>
    </div>
  );
};

const RankingList = ({ list }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const goToContentRankingList = () => {
    dispatch(setSelectedTypeOfTalent([]));
    navigate("/company/content-ranking");
  }

  return (
    <>
      <div className="h-[2.25rem] flex items-center gap-4 mb-4 pl-4">
        <h3 className="flex items-center font-bold text-base alu-text-base-2">
          ランキング
        </h3>
        <CustomButton
          onClick={() => goToContentRankingList()}
          variant="text"
        >
          すべてみる
        </CustomButton>
      </div>
      {list.length > 0 && (
        <div className="p-6 bg-white rounded-2xl flex flex-col gap-3 alu-section-box-shadow">
          {list.map((item: any, idx: any) => (
            <RankingItem key={idx} item={item} />
          ))}
        </div>
      )}
    </>
  );
};

export default RankingList;
